import { TRAITS } from './Base';

export const onGetCharacteristicGiversRequest = (params = [], cb) => ({ params, cb, type: TRAITS.GET_CHARACTERISTIC_GIVERS_REQUEST });
export const onGetCharacteristicGiversSuccess = (payload = {}) => ({ payload, type: TRAITS.GET_CHARACTERISTIC_GIVERS_SUCCESS });
export const onGetCharacteristicGiversFailure = (error = {}) => ({ error, type: TRAITS.GET_CHARACTERISTIC_GIVERS_FAILURE });
